import { render, staticRenderFns } from "./NotificationBadgeDashboard.vue?vue&type=template&id=af9cc658&scoped=true"
import script from "./NotificationBadgeDashboard.vue?vue&type=script&lang=js"
export * from "./NotificationBadgeDashboard.vue?vue&type=script&lang=js"
import style0 from "./NotificationBadgeDashboard.vue?vue&type=style&index=0&id=af9cc658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9cc658",
  null
  
)

export default component.exports